var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "theme-toggle-control",
    class: {
      'theme-toggle-control--menu': _vm.menu
    },
    attrs: {
      "role": "switch",
      "tabindex": "0",
      "aria-checked": String(_vm.isDarkTheme),
      "aria-label": _vm.ariaLabel
    },
    on: {
      "click": _vm.toggle,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }]
    }
  }, [_c('v-icon', {
    staticClass: "theme-toggle-control__icon",
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.isDarkTheme ? 'mdi-white-balance-sunny' : 'mdi-weather-night') + " ")]), _c('span', {
    staticClass: "theme-toggle-control__label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('v-switch', {
    staticClass: "theme-toggle-control__switch",
    attrs: {
      "input-value": _vm.isDarkTheme,
      "color": "blue lighten-1",
      "dense": "",
      "inset": "",
      "hide-details": "",
      "readonly": "",
      "aria-label": _vm.ariaLabel
    },
    nativeOn: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggle.apply(null, arguments);
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }